import { ReactNode } from "react";

export interface DashboardCardProps {
	children: ReactNode;
	/** "default" | "dark" | "alert" control the card's background treatment */
	tone?: "default" | "dark" | "alert";
	className?: string;
	testId?: string;
}

/**
 * Shared card shell used by every dashboard panel so spacing, radius,
 * border and elevation stay consistent across the page. Visual rules live
 * in ClientDashboard.css under `.cd-card` / `.cd-card--dark` / `.cd-card--alert`.
 */
export const DashboardCard = ({ children, tone = "default", className, testId }: DashboardCardProps) => {
	const classNames = [
		"cd-card",
		tone === "dark" && "cd-card--dark",
		tone === "alert" && "cd-card--alert",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div data-testid={testId} className={classNames}>
			{children}
		</div>
	);
};
